/* Package JSON Import will be here */
import React from "react";
import { Form, Input, Button, Row, Col } from "antd";
import { getTranslate } from "react-localize-redux";
import { useSelector, useDispatch } from "react-redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import { loginNew } from "reducers/session";
import { INewLoginPasswordParams } from "models/sessionModels";
import { ButtonSpinner } from "components/Spinner";
import { errorToast } from 'utilities/utils';
/* Project Import will be here */

const PasswordForm = () => {
    const { translate, session } = useSelector((state) => ({
        translate: getTranslate(state.locale),
        session: state.session
    }));

    const dispatch = useDispatch();

    const onSubmitPassword = (values) => {
        const enteredPassword = values.password.trim();

        if (enteredPassword !== "") {
            const requestParam: INewLoginPasswordParams = {
                loginId: values.userName,
                password: values.password
            };

            dispatch(loginNew(requestParam));
        }
        else {
            errorToast({ content: translate("common.error.password") });
        }
    }

    const getFormInitialValues = () => {
        return { userName: session.loginId };
    };

    return (
        <Form
            name="newLoginPasswordForm"
            className="signIn-page"
            onFinish={onSubmitPassword}
            initialValues={getFormInitialValues()}
        >
            <Row>
                <Col span={24} md={24} className="font-12 p-1 font-bold">
                    {translate("session.common.username")}
                </Col>

                <Col span={24} md={24}>
                    <Form.Item
                        name="userName"
                        rules={[{ required: true, message: translate("common.error.userName") }]}>
                        <Input
                            size="large"
                            maxLength={50}
                            disabled
                            placeholder={translate("session.signIn.placeholder.enterUnameOrMNo")}
                            className="sign-in-input-height round-radius"
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={24} md={24} className="font-12 p-1 font-bold">
                    {translate("session.common.password")}
                </Col>

                <Col span={24} md={24}>
                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: translate("common.error.password") }]}>
                        <Input.Password
                            size="large"
                            maxLength={50}
                            placeholder={translate("session.signIn.placeholder.enterPassword")}
                            className="sign-in-input-height round-radius"
                        />
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={24} className="text-center">
                    <Form.Item>
                        <Button
                            disabled={session.isLoading}
                            shape="round"
                            className="sign-in-btn-width mb-1"
                            type="primary"
                            htmlType="submit"
                        >
                            {translate("session.signIn.signIn")}
                            {(session.isLoading) && <ButtonSpinner />}
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};

export default PasswordForm;